import React from "react";
import { useQuery } from "@apollo/client";
import { GET_LANGUAGE } from "graphql/query/language-gql";
import Language from "components/language";
import Settings from "components/settings";
import { PageWrapDefault } from "components/layout";
import { Localize } from "components/service";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";


const basePath = Language.Const.basePath;

const LanguagePage = ({ match, isCreate = false }) => {

    useActiveMenuItem([ "settings-languages" ], [ "settings" ]);

    const pageID = match ? parseInt(match.params.id) : null;

    const { data: { language } = {}, loading } = useQuery(GET_LANGUAGE, {
        skip: isCreate,
        variables: {
            id: pageID
        }
    });

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Settings" }).props.children,
            path: `${ Settings.Const.basePath }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_Languages" }).props.children,
            path: `${ basePath }`
        },
        {
            label: isCreate ?
                Localize({ children: "BREADCRUMBS.Label_Create" }).props.children :
                (language?.label || ''),
            path: isCreate ? `${ basePath }/create` : `${ basePath }/${ pageID }`
        }
    ];

    useBreadCrumbs(breadcrumbs);

    return (
        <PageWrapDefault
            className="page-settings page-languages"
            loading={ loading }
            title={
                isCreate ?
                    <Localize>PAGES.Title_CreateLanguage</Localize> :
                    (!loading && language ? language.label : "Page 404")
            }
            dataExist={ isCreate || (!loading && language) }
            pageNavbar={ false }
            staticPath={ isCreate ? `${ basePath }/create` : `${ basePath }/${ pageID }` }
        >
            <div className="row-grid col-lg-2">
                <div className="col-left">
                    { isCreate ?
                        <Language.Forms.Create /> :
                        language && <Language.Forms.Edit language={ language } />
                    }
                </div>
            </div>
        </PageWrapDefault>
    );
};

export default LanguagePage;
